import React, { useState } from 'react';
import { ScrollMenu } from 'react-horizontal-scrolling-menu';
import { Common } from '@thecvlb/design-system/lib/src';

import { WmPage } from 'services/wm/wm.types';

import { AltSignupStepProps } from 'containers/SignUp/Content/content.types';
import WeightManagementVideo from 'modals/WeightManagementVideo';
import { ScrollVisibilityApiType } from 'widgets/signUp/ProviderInfoCard/SlotsList/slotsList.types';

import { useDrag } from 'hooks/useDrag';

import VideoItem from './VideoItem';

import Stars from 'assets/icons/stars.svg?react';

const videos: string[] = [
  'https://player.vimeo.com/video/1040175440?h=1f4a18feba&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
  'https://player.vimeo.com/video/1040175411?h=09e1365c54&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
  'https://player.vimeo.com/video/1045792257?h=2ef3771461&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
  'https://player.vimeo.com/video/1045792127?h=2faf15a020&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
  'https://player.vimeo.com/video/1045792426?h=23be67ae79&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
  'https://player.vimeo.com/video/1040175359?h=c6adc7877c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
  'https://player.vimeo.com/video/1045792399?h=3ccd2b16ae&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
  'https://player.vimeo.com/video/1045792200?h=5e31283276&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
  'https://player.vimeo.com/video/1045792154?h=0ea11cd33a&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
  'https://player.vimeo.com/video/1045792314?h=f12eeabc13&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
];

const MarketingVideo: React.FC<AltSignupStepProps> = ({ onContinue }) => {
  const { dragStart, dragStop, dragMove } = useDrag();
  const [selectedVideo, setSelectedVideo] = useState<WmPage | null>(null);

  const handleDrag =
    ({ scrollContainer }: ScrollVisibilityApiType) =>
    (ev: React.MouseEvent) =>
      dragMove(ev, (posDiff) => {
        if (scrollContainer.current) {
          scrollContainer.current.scrollLeft += posDiff;
        }
      });

  return (
    <div className="onboarding-page-wrapper">
      <WeightManagementVideo
        isOpen={!!selectedVideo}
        page={selectedVideo}
        onClose={() => setSelectedVideo(null)}
      />
      <div className="flex flex-col gap-2">
        <h2 className="text-center text-mXl font-bold text-primary md:text-2xl">
          LifeMD makes losing weight easy and affordable using your health insurance benefits.
        </h2>
        <p className="mx-0.5 text-center text-[15px] text-primary-700">
          <span className="font-bold">
            Many patients pay as little as $0 to $25 in copays for Ozempic®, Wegovy®, or
            Zepbound®.
          </span>{' '}
          A LifeMD expert will work with your insurance to help get your GLP-1 medication covered.
        </p>
      </div>
      <div className="rounded-xl bg-[#F1F7FA] pb-3 pt-4">
        <h3 className="mb-4 text-center font-bold text-primary">REAL PATIENTS. AMAZING RESULTS.</h3>
        <ScrollMenu
          itemClassName="w-[240px] flex-none aspect-video overflow-hidden rounded-2xl shadow-xl"
          scrollContainerClassName="gap-4 md:gap-6 px-4 md:px-6"
          transitionBehavior={{ behavior: 'smooth' }}
          onMouseDown={() => dragStart}
          onMouseMove={handleDrag}
          onMouseUp={() => dragStop}
        >
          {videos.map((url) => (
            <VideoItem itemId={url} key={url} url={url} />
          ))}
        </ScrollMenu>
        <div className="flex items-center justify-center gap-2 text-primary">
          <h3 className="text-[60px] font-semibold leading-[70px]">4.9</h3>
          <div className="mt-3 flex flex-col gap-1">
            <Stars />
            <span>7,900 REVIEWS</span>
          </div>
        </div>
        <p className="text-center text-mXs text-primary">On Apple App Store and Google Play</p>
      </div>
      <div className="flex flex-col gap-6 text-center">
        <div className="mx-auto flex max-w-[230px] flex-col items-center gap-4">
          <Common.Button color="blue" postIcon="arrow-right" fullWidthOnMobile onClick={onContinue}>
            Continue
          </Common.Button>
          <span className="text-base text-primary">
            <b>Special Offer:</b> Save Up To 40% Off
          </span>
        </div>
        <span className="text-mSm text-gray md:text-base">
          Results may vary based on individual factors, including adherence to the program, starting
          weight, health conditions, and lifestyle changes. Each individual was compensated for
          their time and feedback. Testimonials are not a guarantee of specific results. The LifeMD
          Weight Management Program includes access to licensed healthcare providers, weight loss
          medications when clinically appropriate, and personalized guidance. 
        </span>
      </div>
    </div>
  );
};

export default MarketingVideo;
